import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/extraPayments';

import { decline } from './utils';

export default function* listenDecline() {
  yield takeEvery(actions.decline.type, decline);
}
